import script from "./cost.vue?vue&type=script&setup=true&lang=js"
export * from "./cost.vue?vue&type=script&setup=true&lang=js"

import "./cost.vue?vue&type=style&index=0&id=3249127f&scoped=true&lang=css"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3249127f"]])

export default __exports__